import { booking } from 'constants/Booking.constants';

const initialState = {
  isLoading: false,
  bookingDetails: {},
  failedBookingSlots: [],
  successfulBookings: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case booking.CREATE_BOOKING_LOADING:
      return { ...state, isLoading: action.payload }
    case booking.CREATE_BOOKING_SUCCESS:
      return { ...state, bookingDetails: action.payload }
    case booking.SET_SUCCESSFUL_BOOKINGS:
      return { ...state, successfulBookings: action.payload }
    case booking.SET_FAILED_BOOKING_SLOTS:
      return { ...state, failedBookingSlots: action.payload }
    case booking.CLEAR_BOOKING: {
      return {
        ...state, 
        bookingDetails : {},
        failedBookingSlots: [],
        successfulBookings: [],
      }
    }
    default:
      return state
  }
};

export default reducer;
